<template>
    <a-card size="small" :head-style="{ background: '#f5f5f5' }" :title="$t('submission.all_author.all_authors' /*本论文所有作者*/)" class="mt15">
        <a-button type="primary" @click="handleAuthorEditEvent('', 22)" slot="extra" v-if="config.is_other_author == 1">{{ $t('submission.all_author.add_author' /*添加作者*/) }}</a-button>
        <transition-group name="list" tag="div">
            <a-card
                v-for="(item, index) in authorList"
                :key="index"
                size="small"
                :class="{ mt10: index != 0 }"
                :head-style="{ background: '#fafafa' }"
                :title="$t('submission.all_author.author_number' /*第{number}作者*/, { number: index + 1 })"
            >
                <a-space class="author-icon-wrapper" slot="extra">
                    <a-icon v-if="index != 0" @click="handleAuthorPrevEvent(index)" type="vertical-align-top" />
                    <a-icon v-if="index != authorList.length - 1" @click="handleAuthorNextEvent(index)" type="vertical-align-bottom" />
                    <a-icon type="edit" @click="handleAuthorEditEvent(item.author_id, index == 0 ? 21 : 22)" />
                    <a-icon v-if="index != 0" @click="handleAuthorRemoveEvent(index)" type="delete" />
                </a-space>
                <a-row :gutter="[15, 10]">
                    <a-col :xs="24" :sm="12" :md="8">
                        <div class="flex x-left">
                            <span class="color999">{{ $t('submission.all_author.name' /*姓名*/) }}：</span>
                            <span class="color000">{{ item.real_name }}</span>
                        </div>
                    </a-col>
                    <a-col :xs="24" :sm="12" :md="8">
                        <div class="flex x-left">
                            <span class="color999">{{ $t('submission.all_author.mobile' /*手机*/) }}：</span>
                            <span class="color000">{{ item.mobile }}</span>
                        </div>
                    </a-col>
                    <a-col :xs="24" :sm="12" :md="8">
                        <div class="flex x-left">
                            <span class="color999">{{ $t('submission.all_author.email' /*电子邮箱*/) }}：</span>
                            <span class="color000">{{ item.email }}</span>
                        </div>
                    </a-col>
                    <a-col :xs="24" :sm="12" :md="8" v-if="config.is_tongxun_author">
                        <a-checkbox @change="handleCheckboxChangeEvent(index, 'is_tongxun_author')" v-model="item.is_tongxun_author">
                            {{ $t('submission.all_author.corresponding_author' /*通讯作者*/) }}
                        </a-checkbox>
                    </a-col>
                    <a-col :xs="24" :sm="12" :md="8" v-if="config.is_fayan_author == 1">
                        <a-checkbox @change="handleCheckboxChangeEvent(index, 'is_fayan_author')" v-model="item.is_fayan_author">
                            {{ $t('submission.all_author.speaking_author' /*发言作者*/) }}
                        </a-checkbox>
                    </a-col>
                    <a-col :xs="24">
                        <span class="color999">{{ $t('submission.all_author.belonging_org' /*所属单位*/) }}：</span>
                        <div class="org-list mt5">
                            <div v-for="(it, idx) in item.org_list" :key="idx" class="flex x-left org-item">
                                <span class="color000 flex-item">{{ it.org_cnname }}</span>
                                <span class="color999 mr20">{{ it.address }}</span>
                                <span class="color999">{{ it.zipcode }}</span>
                            </div>
                        </div>
                    </a-col>
                </a-row>
            </a-card>
        </transition-group>
        <add-author ref="addAuthorRef" @reset="getAuthorList"></add-author>
    </a-card>
</template>
<script>
import addAuthor from './add-author.vue';
export default {
    name: 'AllAuthor',
    components: {
        addAuthor
    },
    props: {},
    data() {
        return {
            authorList: [],
            config: {}
        };
    },
    props: {
        abstract_id: {
            default: '',
            type: String
        },
        channel_id: {
            default: 0,
            type: Number
        }
    },
    methods: {
        // 获取作者列表
        getAuthorList() {
            this.loading = true;
            this.$request.post({ url: 'getAbstractAuthorList', data: { abstract_id: this.abstract_id || '' } }).then(res => {
                this.authorList = res.data.List;
                this.authorList.forEach((item, index) => {
                    item.is_tongxun_author = item.is_tongxun_author == 1 ? true : false;
                    item.is_fayan_author = item.is_fayan_author == 1 ? true : false;
                });
            });
        },
        // 复选框改变事件
        handleCheckboxChangeEvent(index, filed) {
            // 修改作者 通讯作者 发言作者状态
            let currItem = this.authorList[index];
            this.$request.post({ url: 'changeAuthorStatus', data: { id: Number(currItem.author_id) || 0, filed } }).then(res => {
                if (currItem[filed]) {
                    this.authorList.forEach((it, idx) => {
                        it[filed] = idx == index ? true : false;
                    });
                }
            });
        },
        // 作者上移
        handleAuthorPrevEvent(index) {
            // TODO: 上移功能
            if (index > 0) {
                const temp = this.authorList[index];
                this.authorSort().then(() => {
                    this.$set(this.authorList, index, this.authorList[index - 1]);
                    this.$set(this.authorList, index - 1, temp);
                });
            }
        },
        // 作者下移
        handleAuthorNextEvent(index) {
            // TODO: 下移功能
            if (index < this.authorList.length - 1) {
                const temp = this.authorList[index];
                this.authorSort().then(() => {
                    this.$set(this.authorList, index, this.authorList[index + 1]);
                    this.$set(this.authorList, index + 1, temp);
                });
            }
        },
        // 作者排序
        authorSort() {
            let sort = [];
            this.authorList.forEach((item, index) => {
                sort.push({
                    data_id: Number(item.author_id),
                    sort: this.authorList.length - index
                });
            });
            return this.$request.post({ url: 'authorSort', data: { sort } });
        },
        // 添加编辑作者
        handleAuthorEditEvent(author_id, type) {
            // TODO: 编辑功能
            this.$refs.addAuthorRef.showFun(author_id, this.abstract_id || '', this.channel_id, this.config, type);
        },
        // 删除
        handleAuthorRemoveEvent(index) {
            let item = this.authorList[index];
            // TODO: 删除功能
            this.$confirm({
                title: `确定要删除该作者【${item.real_name}】？`,
                type: 'warning',
                onOk: () => {
                    this.$request.post({ url: 'delAuthorInfo', data: { id: Number(item.author_id) || 0, abstract_id: this.abstract_id } }).then(res => {
                        this.$message.success('删除成功');
                        this.authorList.splice(index, 1);
                    });
                }
            });
        },
        // 获取通道配置
        getSubmissionChannelInfo() {
            this.$request.post({ url: 'getSubmissionChannelInfo', data: { channel_id: this.channel_id } }).then(res => {
                this.config = res?.data?.info?.config;
            });
        }
    },
    mounted() {
        this.getAuthorList();
        this.getSubmissionChannelInfo();
    }
};
</script>
<style lang="less" scoped>
.author-icon-wrapper {
    /deep/.anticon {
        padding: 5px;
        font-size: 16px;
        border-radius: 3px;
        background: @theme;
        color: #fff;
    }
    /deep/.anticon-delete {
        background-color: @error-color;
    }
}
.org-list {
    border: 1px solid #f1f1f1;
}
.org-item {
    padding: 8px 10px;
    &:not(:last-child) {
        border-bottom: 1px solid #f1f1f1;
    }
}
.list-enter-active,
.list-leave-active {
    transition: all 0.15s ease;
}
.list-enter-from,
.list-leave-to {
    opacity: 0;
    transform: translateX(100px);
}
@media screen and(max-width:768px) {
    .org-item {
        .flex-item {
            flex: auto;
        }
    }
}
</style>
